/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './editor.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../src/app/shared/editor/editor.component';
const styles_EditorComponent:any[] = [i0.styles];
export const RenderType_EditorComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_EditorComponent,data:{}});
export function View_EditorComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_EditorComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'admin-editor',
      ([] as any[]),(null as any),(null as any),(null as any),View_EditorComponent_0,
      RenderType_EditorComponent)),i1.ɵdid(245760,(null as any),0,i2.EditorComponent,
      [i1.ElementRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const EditorComponentNgFactory:i1.ComponentFactory<i2.EditorComponent> = i1.ɵccf('admin-editor',
    i2.EditorComponent,View_EditorComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2VkaXRvci9lZGl0b3IuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2VkaXRvci9lZGl0b3IuY29tcG9uZW50LnRzIiwibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvZWRpdG9yL2VkaXRvci5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2VkaXRvci9lZGl0b3IuY29tcG9uZW50LnRzLkVkaXRvckNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb250ZW50PjwvbmctY29udGVudD4iLCI8YWRtaW4tZWRpdG9yPjwvYWRtaW4tZWRpdG9yPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OzsyQkNBQTs7O29CQ0FBO01BQUE7Z0NBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/editor/editor.component.ngfactory.ts